var map = {
	"./add.svg": "b3c0",
	"./adjustments.svg": "dff7",
	"./arrow-left.svg": "f6db",
	"./arrow-right.svg": "8281",
	"./bold.svg": "d053",
	"./box.svg": "64f0",
	"./cart.svg": "c0c3",
	"./check.svg": "4a24",
	"./clock.svg": "3175",
	"./close.svg": "bb7c",
	"./drag.svg": "1c5c",
	"./eye.svg": "083f",
	"./grid.svg": "14a4",
	"./induline-logo.svg": "d05a",
	"./indupack-logo.svg": "feda",
	"./info.svg": "69d9",
	"./italic.svg": "aa11",
	"./lock.svg": "3b18",
	"./mail.svg": "4f1b",
	"./ol.svg": "069c",
	"./paragraph.svg": "db03",
	"./quote.svg": "deae",
	"./redo.svg": "95f0",
	"./search.svg": "0a17",
	"./sections.svg": "3ebb",
	"./settings.svg": "bc64",
	"./shipping.svg": "2012",
	"./strike.svg": "a65b",
	"./tag.svg": "48ac",
	"./translate.svg": "2df4",
	"./trash.svg": "9961",
	"./ul.svg": "9218",
	"./underline.svg": "63ec",
	"./user.svg": "4d66"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfd9";